module.exports = __webpack_public_path__ + "img/loginImg.3951ac24.png";